// extracted by mini-css-extract-plugin
module.exports = {"comment":"AnswerComment_comment__1rkpB","profilePic":"AnswerComment_profilePic__162wK","wrapper":"AnswerComment_wrapper__2lG0L"};